export enum AdminModules {
    DASHBOARD = 1,
    DASHBOARD_CREATE_POST = 2,
    DASHBOARD_VIEW = 3,

    ADMIN_USER_CONTROL = 4,
    ADMIN_USER_CREATE = 5,
    ADMIN_USER_VIEW = 6,
    ADMIN_USER_EDIT = 7,
    ADMIN_USER_DELETE = 8,

    COMPANY = 9,
    COMPANY_CREATE = 10,
    COMPANY_VIEW = 11,
    COMPANY_EDIT = 12,
    COMPANY_DELETE = 13,

    BILLING = 14,
    BILLING_CREATE = 15,
    BILLING_VIEW = 16,
    BILLING_EDIT = 17,
    BILLING_DELETE = 18,

    LICENSE = 19,
    GENERATE_LICENSE = 20,
    LICENSE_VIEW = 21,
    LICENSE_DELETE = 22,
    BUY_LICENSE = 23,


    ACCESSIBILITIES = 24,
    ACCESSIBILITIES_CREATE = 25,
    ACCESSIBILITIES_VIEW = 26,
    ACCESSIBILITIES_EDIT = 27,
    ACCESSIBILITIES_DELETE = 28,

    MY_PROFILE = 29,
    MY_PROFILE_VIEW = 30,
    MY_PROFILE_EDIT = 31,

    MODULE_SETTINGS = 32,
    MODULE_SETTINGS_CREATE = 33,
    MODULE_SETTINGS_VIEW = 34,
    MODULE_SETTINGS_EDIT = 35,
    MODULE_SETTINGS_DELETE = 36,

    PRICE_SETTINGS = 37,
    PRICE_SETTINGS_CREATE = 38,
    PRICE_SETTINGS_VIEW = 39,
    PRICE_SETTINGS_EDIT = 40,
    PRICE_SETTINGS_DELETE = 41,

    NEWS = 42,
    NEWS_CREATE = 43,
    NEWS_VIEW = 44,
    NEWS_EDIT = 45,
    NEWS_DELETE = 46,

    VENDORS = 47,
    VENDORS_CREATE = 48,
    VENDORS_VIEW = 49,
    VENDORS_EDIT = 50,
    VENDORS_DELETE = 51,

    REGISTRATION_CODES = 52,
    REGISTRATION_CODES_CREATE = 53,
    REGISTRATION_CODES_VIEW = 54,
    REGISTRATION_CODES_EDIT = 55,
    REGISTRATION_CODES_DELETE = 56,

    // INSTANCE_MANAGEMENT = 57,
    // INSTANCE_MANAGEMENT_VIEW = 58,
    INSTANCE_MANAGEMENT = 47,
    INSTANCE_MANAGEMENT_VIEW = 48,
};
